/**
 * Offset Configuration
 *
 * This configuration file defines the structure for managing data offsets and transformations
 * for weather station measurements. It allows applying mathematical operations to sensor data.
 * Contains two main configurations:
 * 1. Form configuration for adding new offset rules
 * 2. Table configuration for displaying existing offset rules
 */

export const offsetFormConfig = {
  title: "Add Offset value",
  fields: [
    {
      name: "field_name",
      label: "Field Name",
      type: "select",
      options: [
        { value: "temperature_ext", label: "Temperature (External)" },
        { value: "humidity_ext", label: "Humidity (External)" },
        { value: "surface_air_pressure", label: "Pressure" },
        { value: "pitch", label: "Pitch" },
        { value: "roll", label: "Roll" },
        { value: "wind_speed", label: "Wind Speed" },
        { value: "wind_direction", label: "Wind Direction" },
        { value: "wind_gust_speed", label: "Wind Gust Speed" },
        { value: "humidity_int", label: "Humidity (Internal)" },
        { value: "wind_gust_direction", label: "Wind Gust Direction" },
        { value: "voltage", label: "Voltage" },
        { value: "surface_downwelling_shortwave_flux", label: "Solar" },
        { value: "snow_depth", label: "Snow Depth" },
        { value: "temperature_int", label: "Temperature (Internal)" },
        { value: "max_air_temp", label: "Max Temperature" },
        { value: "min_air_temp", label: "Min Temperature" },
        { value: "avg_wnd_spd_pst2mts", label: "2-min Wind Speed" },
        { value: "avg_wnd_dir_pst2mts", label: "2-min Wind Direction" },
        { value: "thickness_of_rainfall_amount", label: "Rainfall" },
        { value: "visibility_in_air", label: "Visibility" },
        { value: "surface_downwelling_longwave_flux", label: "Downwelling Longwave" },
        { value: "surface_upwelling_shortwave_flux", label: "Upwelling Shortwave" },
        { value: "surface_upwelling_longwave_flux", label: "Upwelling Longwave" },
      ],
    },
    {
      name: "operator",
      label: "Operator",
      type: "select",
      options: [
        { value: "+", label: "Add" },
        { value: "-", label: "Subtract" },
        { value: "*", label: "Multiply" },
        { value: "/", label: "Divide" },
        { value: "%", label: "Modulo" },
        { value: "abs", label: "Absolute Value" },
        { value: "round", label: "Round" },
        { value: "floor", label: "Floor" },
        { value: "ceiling", label: "Ceiling" },
        { value: "custom", label: "Custom Expression" }, // New option
      ],
    },

    { name: "offset_value", label: "Offset value", type: "number" },

    {
      name: "aws_mapping_id",
      label: "Station",
      type: "select",
      options: [], // This will be populated dynamically
    },
    { name: "from_date", label: "From Date", type: "datetime-local" },
    {
      name: "to_date",
      label: "To Date",
      type: "datetime-local",
    },
    { name: "comment", label: "Comment", type: "text" },
  ],
  validationSchema: {
    field_name: { required: true },
    // offset_value: { required: true },
    operator: { required: true },
    aws_mapping_id: { required: true },
    from_date: { required: true },
  },
};

/**
 * Table Configuration for Offsets
 * Defines the structure for displaying offset rules in a table format
 */
export const offsetTableConfig = {
  TableId: "offsets",
  offsetTableTitle: "Offset Data",
  offsetTableHeaders: [
    "ID",
    "Station",
    "Field Name",
    "offset Value",
    "Operator",
    "From Date",
    "To Date",
    "Comment",
  ],
};
